export default "__VITE_ASSET__CM4JPhzN__"